import { createStore } from 'vuex'

export const storeApp = createStore({
  state: () => {
    return {
      accessToken: localStorage,
      loading: false,
      showMenu: false,
      menuOpen: false,
      activeSubMenu: null,
      selectedMenu: 'Inicio',
      setMenuCoverage: false,

      userName: undefined,
      userPhoto: undefined,
      userRole: undefined,
      companyName: undefined,
      companyLogo: undefined,
      permissions: undefined

      // client app
      // client_access_token: null

    }
  },
  getters: {
    getMenuState: (state) => state.showMenu,
    getUserName: (state) => state.userName = localStorage.getItem('__user_name'),
    getUserPhoto: (state) => state.userPhoto = localStorage.getItem('__user_photo'),
    getUserRole: (state) => state.userRole = localStorage.getItem('__user_role'),
    getCompanyName: (state) => state.companyName = localStorage.getItem('__company_name'),
    getCompanyLogo: (state) => state.companyLogo = localStorage.getItem('__company_logo'),
    getPermissions: (state) => state.permissions = localStorage.getItem('__permissions')

    // getClientAccessToken: (state) => state.client_access_token = Cookies.get('access_token')
  },
  mutations: {
    setImageMenu (state, payload) {
      localStorage.removeItem('__company_logo')
      state.companyLogo = localStorage.setItem(payload.key, payload.value)
    },
    expandedMenu (state, value) {
      state.menuOpen = value
      state.setMenuCoverage = value
    },
    setActiveSubMenu (state, menu) {
      state.activeSubMenu = menu
    },
    clearActiveSubMenu (state) {
      state.activeSubMenu = null
    },
    showActivateMenu (state, value) {
      state.selectedMenu = value
    },
    showMenuIfLogged (state, value) {
      state.showMenu = value
    },
    SET_USER_NAME (state, payload) {
      localStorage.removeItem('__user_name')
      state.userName = localStorage.setItem(payload.key, payload.value)
    },
    SET_USER_PHOTO (state, payload) {
      localStorage.removeItem('__user_photo')
      state.userPhoto = localStorage.setItem(payload.key, payload.value)
    },
    SET_USER_ROLE (state, payload) {
      localStorage.removeItem('__user_role')
      state.userRole = localStorage.setItem(payload.key, payload.value)
    },
    SET_COMPANY_NAME (state, payload) {
      localStorage.removeItem('__company_name')
      state.companyName = localStorage.setItem(payload.key, payload.value)
    },
    SET_COMPANY_LOGO (state, payload) {
      localStorage.removeItem('__company_logo')
      state.companyLogo = localStorage.setItem(payload.key, payload.value)
    },
    SET_PERMISSIONS_DATA (state, payload) {
      localStorage.removeItem('__permissions')
      state.permissions = localStorage.setItem(payload.key, payload.value)
    },
    showActivateMenu (state, value) {
      state.selectedMenu = value
    }
  },
  actions: {
    setCompanyMenuLogo ({ commit }, value) {
      commit('setImageMenu', value)
    },
    setMenuExpanded ({ commit }, value) {
      commit('expandedMenu', value)
    },
    setActivatedMenu ({ commit }, value) {
      commit('showActivateMenu', value)
    },
    showMenuUserLogged ({ commit }) {
      commit('showMenuIfLogged', true)
    },
    hiddenMenuUserLoggedOut ({ commit }) {
      commit('showMenuIfLogged', false)
    },
    setUserAuthenticated ({ commit }, value) {
      // pode haver mais chamadas - não removido
    },
    setUserName ({ commit }, value) {
      commit('SET_USER_NAME', value)
    },
    setUserPhoto ({ commit }, value) {
      commit('SET_USER_PHOTO', value)
    },
    setUserRole ({ commit }, value) {
      commit('SET_USER_ROLE', value)
    },
    setCompanyName ({ commit }, value) {
      commit('SET_COMPANY_NAME', value)
    },
    setCompanyLogo ({ commit }, payload) {
      commit('SET_COMPANY_LOGO', payload)
    },
    setPermissionsData ({ commit }, payload) {
      commit('SET_PERMISSIONS_DATA', payload)
    },
    cleanLocalStorageDataUser () {
      localStorage.clear()
    },
    setActivatedMenu ({ commit }, value) {
      commit('showActivateMenu', value)
    }
  }
})
